import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { routes } from "./RoutePath";
import { useSelector } from "react-redux";

const AllRoutes = () => {
  const location = useLocation();

  console.log("location Before", location);

  const { user } = useSelector((state) => state.auth);


   const isSuperAdmin =  user?.userType === "SUPER_VENDOR";

  const currentRoute = routes.find((route) => {
    const routeBase = route.path.split("/:")[0];
    return location.pathname.startsWith(routeBase);
  });
  console.log("currentRoute", currentRoute);
  console.log("isSuperAdmin After", isSuperAdmin);

  if (isSuperAdmin && currentRoute && !currentRoute.superAdminAllowed) {
    return <Navigate to="/Orders" replace />;
  }

  return (
    <>
      <Routes>
        {routes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={<route.component />}
            ></Route>
          );
        })}

        <Route
          path="/"
          element={
            <Navigate to={isSuperAdmin ? "/Orders" : "/dashBoard"} replace />
          }
        />

        {/* <Route path="/" element={<Navigate to="/dashBoard" />} /> */}
      </Routes>
    </>
  );
};

export default AllRoutes;
